export const UC_API_PREFIX = '/api/2.1/unity-catalog';
export const UC_AUTH_API_PREFIX = '/api/1.0/unity-control';
